module.exports = __webpack_public_path__ + "img/pic_hhzw_img.097b04d4.png";